import React from "react";
import { Link } from "react-scroll";
import { ReactTyped } from "react-typed";

const Hero = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero__orb hero__orb--cyan" />
      <div className="hero__orb hero__orb--pink" />

      <div className="container">
        <div className="row align-items-center">
          {/* ── LEFT: Content ── */}
          <div
            className="col-lg-6"
            data-aos="fade-right"
            data-aos-duration="900"
            data-aos-delay="100"
          >
            <div className="hero__content">
              <div className="hero__badge">
                <span className="hero__badge-dot" />
                Available for opportunities
              </div>

              <h1 className="hero__name">
                Abdul{" "}
                <span className="hero__name-accent">Aziz</span>
                .
              </h1>

              <div className="hero__role">
                <span className="hero__role-prefix">I&rsquo;m a&nbsp;</span>
                <ReactTyped
                  strings={[
                    "Problem Solver",
                    "Frontend Developer",
                    "Web Designer",
                    "CS Student",
                  ]}
                  typeSpeed={70}
                  backSpeed={45}
                  backDelay={2000}
                  cursorChar="|"
                  loop
                  className="hero__typed"
                />
              </div>

              <p className="hero__bio">
                Crafting digital experiences at the intersection of design and engineering.
                Passionate about clean code, algorithmic thinking, and building products that make an impact.
              </p>

              <div className="hero__actions">
                <Link
                  to="projects"
                  smooth={true}
                  duration={700}
                  offset={-70}
                  className="btn-glow"
                >
                  <span>View My Work</span>
                </Link>
                <a
                  href="https://drive.google.com/uc?export=download&id=15prwQNUrJ_AbSzl4OsoGDNq4BRc4gg6B"
                  className="btn-ghost"
                  target="_blank"
                  rel="noreferrer"
                >
                  Download CV
                </a>
              </div>

              <div className="hero__stats">
                <div className="hero__stat">
                  <span className="hero__stat-number">500+</span>
                  <span className="hero__stat-label">Problems Solved</span>
                </div>
                <div className="hero__stat-divider" />
                <div className="hero__stat">
                  <span className="hero__stat-number">3★</span>
                  <span className="hero__stat-label">CodeChef</span>
                </div>
                <div className="hero__stat-divider" />
                <div className="hero__stat">
                  <span className="hero__stat-number">6+</span>
                  <span className="hero__stat-label">Projects Built</span>
                </div>
              </div>
            </div>
          </div>

          {/* ── RIGHT: Image ── */}
          <div
            className="col-lg-6"
            data-aos="fade-left"
            data-aos-duration="900"
            data-aos-delay="200"
          >
            <div className="hero__image-wrapper">
              <div className="hero__image-glow" />

              <div className="hero__image-frame">
                <img
                  src="assets/images/hero_image.jpg"
                  alt="Abdul Aziz"
                  className="hero__image"
                />
              </div>

              <div className="hero__floating-tag hero__floating-tag--1">
                💡 Problem Solver
              </div>
              <div className="hero__floating-tag hero__floating-tag--2">
                ⭐ 3★ CodeChef
              </div>
              <div className="hero__floating-tag hero__floating-tag--3">
                🔥 500+ Problems
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero__scroll">
        <span className="hero__scroll-text">Scroll</span>
        <div className="hero__scroll-line" />
      </div>
    </section>
  );
};

export default Hero;
